import { InjectionToken } from '@angular/core';

/**
 * token to inject to retrieve data from dialog
 */
export const KAL_DIALOG_DATA = new InjectionToken<{}>('KalDialogData');
